"use strict";

var CADESCOM_CADES_BES = 1;
var CADESCOM_CADES_T = 0x05;
var CADESCOM_CADES_X_LONG_TYPE_1 = 0x5d;
var CAPICOM_CURRENT_USER_STORE = 2;
var CAPICOM_MY_STORE = "My";
var CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED = 2;
var CAPICOM_CERTIFICATE_FIND_SUBJECT_NAME = 1;
var CADESCOM_BASE64_TO_BINARY = 1;
var CAPICOM_ENCODE_BASE64 = 0;
var CADESCOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME = 0;
var CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME = 1;

var CERT_DATA_ENCIPHERMENT_KEY_USAGE = 0x10;
var CERT_KEY_ENCIPHERMENT_KEY_USAGE = 0x20;
var CERT_DIGITAL_SIGNATURE_KEY_USAGE = 0x80;
var CERT_NON_REPUDIATION_KEY_USAGE = 0x40;
var XCN_NCRYPT_ALLOW_EXPORT_FLAG = 0x01;

var CRYPT_STRING_ANY = 0x7;

var ContextUser = 1;
var AllowNone = 0;

app.factory('CryptoProChromeServiceImpl', ['$http', '$q', '$rootScope', 'CryptoBaseServiceImpl',
    function ($http, $q, $rootScope, CryptoBaseServiceImpl) {
        var service = angular.copy(CryptoBaseServiceImpl);
        service.init = function (handler) {
            var _this = this;

            return $q(function (result) {
                window.addEventListener("message", function (event) {
                        if (cadesplugin.CreateObjectAsync) {
                            result({
                                result: true,
                                handler: handler
                            });
                        }
                        else {
                            _this.errors.push('Версия с поддержкой асинхронных вызовов отключена');
                            result({
                                result: false,
                                handler: handler
                            });
                        }
                    },
                    false
                );

                window.postMessage("cadesplugin_echo_request", "*");
            });
        };

        service.sign = function (cert, data, detached) {
            var _this = this;
            if (!detached) detached = false;

            return $q(function (result, error) {
                cadesplugin.async_spawn(function* () {
                    let sSignedMessage;
                    let err = '';
                    try {
                        var oSigner = yield cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner");
                    } catch (ex) {
                        console.log(ex);
                        _this.errors.push(ex);
                        error(ex);
                    }

                    if (oSigner) {
                        yield oSigner.propset_Certificate(cert.certificate.cert);
                    }
                    else {
                        err = "Failed to create CAdESCOM.CPSigner";
                        console.log(err);
                        _this.errors.push(err);
                        error(ex);
                    }

                    var oSignedData = yield cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData");

                    yield oSignedData.propset_Content(data);

                    try {
                        sSignedMessage = yield oSignedData.SignCades(oSigner, CADESCOM_CADES_BES, detached);
                        result(sSignedMessage);
                    }
                    catch (ex) {
                        _this.errors.push(ex);
                        console.log(ex);
                        error(ex);
                    }

                    result(sSignedMessage);
                });
            });
        };

        service.signBase64 = function (cert, data, detached) {
            var _this = this;
            if (!detached) detached = false;

            return $q(function (result, error) {
                cadesplugin.async_spawn(function* () {
                    let sSignedMessage;
                    try {
                        var oSigner = yield cadesplugin.CreateObjectAsync("CAdESCOM.CPSigner");
                    } catch (ex) {
                        console.log(ex);
                        _this.errors.push(ex);
                        error(ex);
                    }
                    if (oSigner) {
                        yield oSigner.propset_Certificate(cert.certificate.cert);
                    }
                    else {
                        let err = "Failed to create CAdESCOM.CPSigner";
                        console.log(err);
                        _this.errors.push(err);
                        error(ex);
                    }

                    var oSignedData = yield cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData");

                    yield oSignedData.propset_ContentEncoding(CADESCOM_BASE64_TO_BINARY);
                    yield oSignedData.propset_Content(data);

                    try {
                        sSignedMessage = yield oSignedData.SignCades(oSigner, CADESCOM_CADES_BES, detached);
                        result(sSignedMessage);
                    }
                    catch (ex) {
                        console.log(ex);
                        _this.errors.push(ex);
                        error(ex);
                    }

                    result(sSignedMessage);
                });
            });
        };

        service.verify = function (message, cert, detached) {
            if (!detached) detached = false;

            var _this = this;

            return $q(function (result, error) {
                cadesplugin.async_spawn(function* () {
                    var oSignedData = yield cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData");

                    try {
                        yield oSignedData.VerifyCades(message, CADESCOM_CADES_BES, detached);
                    }
                    catch (ex) {
                        console.log(ex);
                        _this.errors.push(ex);
                        error(ex);
                    }

                    result(true);
                })
            });
        };

        service.verifyBase64 = function (message, cert, detached, data) {
            if (!detached) detached = false;

            var _this = this;

            return $q(function (result, error) {
                cadesplugin.async_spawn(function* () {
                    var oSignedData = yield cadesplugin.CreateObjectAsync("CAdESCOM.CadesSignedData");

                    yield oSignedData.propset_ContentEncoding(CADESCOM_BASE64_TO_BINARY);
                    yield oSignedData.propset_Content(data);

                    try {
                        yield oSignedData.VerifyCades(message, CADESCOM_CADES_BES, detached);
                    }
                    catch (ex) {
                        console.log(ex);
                        _this.errors.push(ex);
                        error(ex);
                    }

                    result(true);
                })
            });
        };

        service.selectCertificate = function (data) {
            $rootScope.$emit('cryptoproCertificate', data);

            return $q(function (result) {
                $rootScope.$on('selectCryptoproCertificate', function (event, data) {
                    result(data);
                });
            });
        };

        service.getCertificates = function (deviceId) {
            let _this = this;
            let err = '';

            return $q(function (result) {
                cadesplugin.async_spawn(function* () {
                    let myStoreExists = true;
                    let oStore = null;

                    try {
                        oStore = yield cadesplugin.CreateObjectAsync("CAdESCOM.Store");
                        if (!oStore) {
                            err = "CADES API Error: Create store failed";
                            console.log(err);
                            _this.errors.push(err);
                            result(false);
                        }

                        yield oStore.Open();
                    }
                    catch (ex) {
                        myStoreExists = false;
                    }

                    if (myStoreExists) {
                        try {
                            let certs = yield oStore.Certificates;
                            let certCnt = yield certs.Count;

                            let certsOut = [];
                            for (let i = 1; i <= certCnt; i++) {
                                let cert;
                                try {
                                    cert = yield certs.Item(i);
                                }
                                catch (ex) {
                                    err = "CADES API Error: " + cadesplugin.getLastError(ex);
                                    console.log(err);
                                    _this.errors.push(err);
                                    return;
                                }

                                try {
                                    let ValidFromDate = new Date((yield cert.ValidFromDate));
                                    certsOut.push({
                                        id: i,
                                        cert: cert,
                                        name: new CertificateAdjuster().GetCertInfoString(yield cert.SubjectName, ValidFromDate),
                                        serialNumber: yield cert.SerialNumber,
                                    });
                                }
                                catch (ex) {
                                    err = "CADES API Error: " + cadesplugin.getLastError(ex);
                                    console.log(err);
                                    _this.errors.push(err);
                                }
                            }

                            result(certsOut);
                        }
                        catch (ex) {
                            err = "CADES API Error: " + cadesplugin.getLastError(ex);
                            console.log(err);
                            _this.errors.push(err);
                            result(false);
                        }

                        yield oStore.Close();
                    }
                });

            });
        };

        /**
         * @param data
         * @param dn
         * @returns {*}
         */
        service.createRequest = function (data, dn) {
            return $q(function (result) {
                cadesplugin.async_spawn(function* (arg) {
                    let gost2012 = data.model.orderItem.catalogItem.isGost2012;

                    let PKey = yield cadesplugin.CreateObjectAsync("X509Enrollment.CX509PrivateKey");
                    yield PKey.propset_ProviderName(gost2012 ?
                            "Crypto-Pro GOST R 34.10-2012 Cryptographic Service Provider" :
                            "Crypto-Pro GOST R 34.10-2001 Cryptographic Service Provider");
                    yield PKey.propset_ProviderType(gost2012 ? 80 : 75);
                    yield PKey.propset_ExportPolicy(XCN_NCRYPT_ALLOW_EXPORT_FLAG);
                    yield PKey.propset_KeySpec(1);  // XCN_AT_KEYEXCHANGE

                    let CertificateRequestPkcs10 = yield cadesplugin.CreateObjectAsync("X509Enrollment.CX509CertificateRequestPkcs10");
                    yield CertificateRequestPkcs10.InitializeFromPrivateKey(0x1, PKey, "");

                    let DistinguishedName = yield cadesplugin.CreateObjectAsync("X509Enrollment.CX500DistinguishedName");
                    yield DistinguishedName.Encode("CN=" + dn);
                    yield CertificateRequestPkcs10.propset_Subject(DistinguishedName);

                    let ObjectId = yield cadesplugin.CreateObjectAsync("X509Enrollment.CObjectId");
                    let X509ExtensionTemplateV2 = yield cadesplugin.CreateObjectAsync("X509Enrollment.CX509ExtensionTemplate");

                    yield ObjectId.InitializeFromValue(data.model.template.oid);
                    yield X509ExtensionTemplateV2.InitializeEncode(ObjectId, 1, 0);
                    (yield CertificateRequestPkcs10.X509Extensions).Add(X509ExtensionTemplateV2);

                    let KeyUsageExtension = yield cadesplugin.CreateObjectAsync("X509Enrollment.CX509ExtensionKeyUsage");

                    yield KeyUsageExtension.InitializeEncode(
                        CERT_KEY_ENCIPHERMENT_KEY_USAGE |
                        CERT_DATA_ENCIPHERMENT_KEY_USAGE |
                        CERT_DIGITAL_SIGNATURE_KEY_USAGE |
                        CERT_NON_REPUDIATION_KEY_USAGE);
                    (yield CertificateRequestPkcs10.X509Extensions).Add(KeyUsageExtension);

                    let Enroll = yield cadesplugin.CreateObjectAsync("X509Enrollment.CX509Enrollment");
                    yield Enroll.InitializeFromRequest(CertificateRequestPkcs10);

                    //  Формирование запроса
                    let pkcs10 = yield Enroll.CreateRequest(1);

                    console.log(pkcs10);
                    result(pkcs10);
                });
            });
        };

        service.getSerial = function (certificate) {
            return certificate.certificate.serialNumber;
        };

        service.install = function (data) {
            var _this = this;

            return $q(function (result) {
                cadesplugin.async_spawn(function* (arg) {
                    let objEnroll = yield cadesplugin.CreateObjectAsync("X509Enrollment.CX509Enrollment");

                    try {
                        yield objEnroll.Initialize(ContextUser);
                        yield objEnroll.InstallResponse(AllowNone, data.model.rawCertificate, CRYPT_STRING_ANY, "");
                        result(true);
                    }
                    catch (e) {
                        if (e.number == -2146885628) {
                            bootbox.alert("Невозможно установить сертификат, т.к. не удается связать сертификат с закрытым ключом.\nСохраните сертификат и воспользуйтесь инструментами системы или криптопровайдера для его установки.");
                        }
                        else {
                            bootbox.alert(e.message + " |" + e.number + "|");
                        }

                        result(false);
                    }
                });
            });
        };

        service.getVersion = function () {
            var _this = this;
            return $q(function (result) {
                result(cadesplugin.JSModuleVersion);
            });
        };

        return service;
    }]);

function CertificateAdjuster() {
}

CertificateAdjuster.prototype.extract = function (from, what) {
    let certName = "";

    var begin = from.indexOf(what);

    if (begin >= 0) {
        var end = from.indexOf(', ', begin);
        certName = (end < 0) ? from.substr(begin) : from.substr(begin, end - begin);
    }

    return certName;
};

CertificateAdjuster.prototype.Print2Digit = function (digit) {
    return (digit < 10) ? "0" + digit : digit;
};

CertificateAdjuster.prototype.GetCertDate = function (paramDate) {
    let certDate = new Date(paramDate);
    return this.Print2Digit(certDate.getUTCDate()) + "." + this.Print2Digit(certDate.getMonth() + 1) + "." + certDate.getFullYear() + " " +
        this.Print2Digit(certDate.getUTCHours()) + ":" + this.Print2Digit(certDate.getUTCMinutes()) + ":" + this.Print2Digit(certDate.getUTCSeconds());
};

CertificateAdjuster.prototype.GetCertName = function (certSubjectName) {
    return this.extract(certSubjectName, 'CN=');
};

CertificateAdjuster.prototype.GetIssuer = function (certIssuerName) {
    return this.extract(certIssuerName, 'CN=');
};

CertificateAdjuster.prototype.GetCertInfoString = function (certSubjectName, certFromDate) {
    return this.extract(certSubjectName, 'CN=') + "; Выдан: " + this.GetCertDate(certFromDate);
};